module.exports = __webpack_public_path__ + "img/wx_account.7d927c49.png";